export const normalizeIp = (address: string) => {
    if (address && address.endsWith('/32')) {
        return address.substring(0, address.length - 3)
    }
    return address
}
